<template>
  <div>
    <h3>Select a location to begin receiving surveys</h3>
    <!-- <ul>
      <li v-for="loc in locations" :key="loc.id">
        <router-link
          :to="{ name: 'surveyPin', params: { locId: loc.id }}"
        >{{ loc.name }}from{{ loc.dateCreated }}to{{ loc.toDate }}</router-link>
      </li>
    </ul>-->
    <div>
      <b-button size="lg" :to="{ name: 'surveyAdd' }">Survey Mode</b-button>
    </div>
    <div>
      <b-button size="lg" :to="{ name: 'home' }">Cancel</b-button>
    </div>
  </div>
</template>

<script>
import ajax from "@/resources/myApi.js";

export default {
  name: "app-survey-locations",
  data: () => ({
    locations: []
  }),
  methods: {
    async onLoad() {
      console.log("another onload2");
      try {
        ajax.get('locations/active'
        ).then(respone => this.locations = respone.data)
      } catch (err) {
        console.log(err);
      }
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>
